module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAOCAYAAAD5YeaVAAABCUlEQVQoU5WSPS9DARSGn/e2TYQOLEIQJqNFejuR/gASMWkbq+SKSHwMpqZitFDaRmKrpDb/gDA0YTBY/ASJxSIs1z1yJVckemnPdM7J856cL9GFqeDWLoEBQ1vNOy/0Y015t3YjmAEMdJZIst1oec/tFMrlysnht6F1EewCaeAFJXYmb59Oy5SDnyJFwVKmOuZIFWAhzAlagY/XvF99iJhvOErkM9V5SUfAOOBjHMjRo6Xs4hccipan9vv8nnRJ2AaQ+ipkOm8Lr0yf9L46HyXE5p9w0T2eM5ywjYnYNorZyqiRPMRYjB0wXN3I++CaGXv/rq7g1q/BZjs6Sj5bv5JZf0fn7uKP+ARToGEjlfHI6AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/rightTip.png
// module id = cV/4
// module chunks = 1